











































import Vue from 'vue';
import Component, {mixins} from 'vue-class-component';
import {DateMixin} from '@/modules/core/date';
import {PaginationInput} from '@/modules/core/model/pagination';
import {VDataTableOptions} from '@/types';
import {Action} from 'vuex-class';
import {BulkOperationState} from '@/modules/reservation/model/BulkOperation';

@Component
export default class ReservationBulkListPreview extends mixins(DateMixin) {
    /**
     * Solicita a la aplicación que cargue en el estado de una paginación de la
     * lista de reservas que van a ser insertadas mediante el creador
     * masivo de reservas
     */
    @Action('reservation/loadReservationBulkList')
    public loadReservationBulkList: (input: PaginationInput) => void

    /**
     * Cabeceras de la table que muestra las filas que se van a insertar
     */
    public headers = [
        {text: 'Departamento', value: 'reservation.department.name', sortable: false},
        {text: 'Tipo', value: 'reservation.department.type.name', sortable: false},
        {text: 'Desde', value: 'reservation.dateStart', sortable: false},
        {text: 'Hasta', value: 'reservation.dateEnd', sortable: false},
        { text: 'Estado', value: 'state', sortable: false},
    ];

    public paginationInput: PaginationInput = {
        page: 1,
        recordsPerPage: 50,
    }

    public loading = false
    public select = [];


    /**
     * Método invocado cuando la table notifica
     *
     * @param $event
     */
    public async updateTable ($event: VDataTableOptions) {
        Object.assign(this.paginationInput, {
            page: $event.page,
            recordsPerPage: $event.itemsPerPage,
        })

        await this.loadPagination()
    }

    public clear () {
        this.$store.dispatch('reservation/clearBulkCreator')
        this.$emit('clear')
    }

    public beforeDestroy () {
        this.$store.dispatch('reservation/clearReservationBulkList')
    }

    public async loadPagination () {
        this.loading = true
        await this.loadReservationBulkList(this.paginationInput)
        this.loading = false
    }
}
